import './index.scss';
import classnames from 'classnames';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import PermissionChecker from '~/components/permission_checker';
import { fetchComparisonPdfs, } from '~/redux/reducers/states/comparison_documents';
import Permissions from '~/settings/permissions';
import getDoesCommentExist from '~/utils/getDoesCommentExist';
import syncScroll from '~/utils/syncScroll';
import CommentNotAvailableModal from './comments/not-available-modal';
import ComparisonGridTable from './grid_table';
import DocumentComparisonHeader from './header';
import { ComparisonGridProvider, useComparisonGrid } from './providers/comparison_grid';
import { DocumentComparisonProvider, useDocumentComparison } from './providers/document_comparsion';
const DocumentGridView = () => {
    const dispatch = useDispatch();
    const { commentId } = useParams();
    const { areComparisonDocumentsLoading, isFetchingComparisonDocPdfs, } = useSelector(state => state.comparisonDocumentsState);
    const { comparisonDocuments, anchorDocId } = useDocumentComparison();
    const { anchorDoc, comparatorDocs, } = useComparisonGrid();
    const [redirectCommentDoesNotExist, setRedirectCommentDoesNotExist] = useState(false);
    useEffect(() => {
        if (comparisonDocuments.length &&
            !comparisonDocuments.every(doc => doc.blob) &&
            !isFetchingComparisonDocPdfs) {
            dispatch(fetchComparisonPdfs({ comparisonDocuments }));
        }
        if (comparisonDocuments.length && commentId) {
            setRedirectCommentDoesNotExist(!(commentId
                ? getDoesCommentExist(commentId, comparisonDocuments)
                : false));
        }
    }, [anchorDocId, comparisonDocuments]);
    useEffect(() => {
        syncScroll.reset();
    }, [areComparisonDocumentsLoading, comparisonDocuments, anchorDoc, comparatorDocs]);
    if (areComparisonDocumentsLoading ||
        (comparisonDocuments === null || comparisonDocuments === void 0 ? void 0 : comparisonDocuments.length) === 0 ||
        !anchorDoc || !comparatorDocs.length) {
        return React.createElement("div", { className: 'loading-documents' },
            React.createElement(LoadingElement, { isLightBackground: true, text: 'Loading Documents for Comparison...', heading: true, large: true }));
    }
    const gridContainerClass = classnames('old-comparison-grid-container', {
        one: comparatorDocs.length === 1,
        two: comparatorDocs.length === 2,
    });
    return (React.createElement(React.Fragment, null,
        redirectCommentDoesNotExist && (React.createElement(CommentNotAvailableModal, { hideModal: () => setRedirectCommentDoesNotExist(false) })),
        React.createElement("div", { className: 'main-content page-content-wrapper' },
            React.createElement("div", { className: gridContainerClass },
                React.createElement(DocumentComparisonHeader, null),
                React.createElement(ComparisonGridTable, null)))));
};
const DocumentGridViewWrapper = () => {
    return React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.BROWSE_GRID_VIEW] },
        React.createElement(DocumentComparisonProvider, null,
            React.createElement(ComparisonGridProvider, null,
                React.createElement(DocumentGridView, null))));
};
export default DocumentGridViewWrapper;
